<template>
  <div class="password-recovery">
    <router-link
      :to="{ name: 'login' }"
      class="recovery-back"
    >
      <GrowthIcon name="arrow" />{{ $t('auth.back-to-login') }}
    </router-link>
    <header class="auth-welcome">
      <div class="recovery-symbol">
        <GrowthIcon :name="icon" />
      </div>
      <p class="growth-eyebrow">
        {{ $t('auth.password-recovery') }}
      </p>
      <h1
        ref="heading"
        class="welcome-title"
        tabindex="-1"
      >
        {{ title }}
      </h1>
      <p class="welcome-subtitle">
        {{ description }}
      </p>
    </header>
    <div class="tw:grid tw:gap-5">
      <slot />
    </div>
    <footer class="recovery-help">
      {{ $t('auth.need-help') }}
      <a
        href="https://help.indiefy.net/"
        target="_blank"
        rel="noopener noreferrer"
      >{{ $t('auth.contact-support') }} ↗</a>
    </footer>
  </div>
</template>
<script setup>
import { nextTick, ref, watch } from 'vue';
import GrowthIcon from '@/components/growth/GrowthIcon.vue';
const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  icon: { type: String, default: 'link' },
  focusTitle: { type: Boolean, default: true },
});
const heading = ref(null);
watch(() => props.title, async () => {
  await nextTick();
  if (props.focusTitle) heading.value?.focus();
});
</script>
<style>
.password-recovery { color: var(--growth-ink, #20221f); }
.password-recovery .recovery-back { display: inline-flex; align-items: center; gap: 8px; min-height: 44px; margin-bottom: 20px; color: var(--growth-muted, #62665d); font-size: 12px; }
.password-recovery .recovery-back svg { width: 16px; height: 16px; transform: rotate(180deg); }
.recovery-symbol { display: grid; place-items: center; width: 54px; height: 54px; margin-bottom: 24px; border: 1px solid var(--growth-line, #e0e3d9); border-radius: 18px; background: var(--growth-purple, #ded5f5); color: #393048; }
.recovery-symbol svg { width: 25px; height: 25px; }
.password-recovery .welcome-title:focus { outline: none; }
.password-recovery .recovery-card { padding: 20px; background: var(--growth-card, #fff); border: 1px solid var(--growth-line, #e0e3d9); border-radius: 16px; }
.password-recovery .recovery-copy { color: var(--growth-muted, #62665d); font-size: 13px; line-height: 1.8; margin: 0; }
.password-recovery .recovery-address { display: block; margin: 8px 0 14px; font-size: 15px; overflow-wrap: anywhere; }
.password-recovery .recovery-action { width: 100%; border-radius: 12px; min-height: 50px; white-space: normal; }
.password-recovery .recovery-action svg { width: 18px; height: 18px; flex-shrink: 0; }
.password-recovery .recovery-error { color: var(--color-danger, #a14a40); border-left: 3px solid currentColor; padding: 10px 14px; background: var(--growth-card, #fff); font-size: 13px; line-height: 1.7; }
.password-recovery .recovery-text-action { border: 0; background: none; padding: 10px 0; min-height: 44px; color: var(--growth-ink, #20221f); text-decoration: underline; text-underline-offset: 4px; font: inherit; font-size: 12px; cursor: pointer; }
.password-recovery .recovery-help { display: flex; flex-wrap: wrap; gap: 4px 8px; align-items: center; padding-top: 24px; margin-top: 26px; border-top: 1px solid var(--growth-line, #e0e3d9); color: var(--growth-muted, #62665d); font-size: 12px; }
.password-recovery .recovery-help a { color: var(--growth-ink, #20221f); min-height: 32px; display: inline-flex; align-items: center; text-decoration: underline; text-underline-offset: 4px; }
.password-recovery .recovery-spinner { width: 17px; height: 17px; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%; animation: recovery-spin .8s linear infinite; }
.password-recovery :is(a,button):focus-visible { outline: 2px solid var(--color-primary, #667d46); outline-offset: 4px; }
@keyframes recovery-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .password-recovery .recovery-spinner { animation: none; } }
</style>
